export type OtpComponentResources = {
    [K in 'contactInfoInputLabel' |
    'contactInfoMobileInputLabel' |
    'contactInfoEmailInputLabel' |
    'contactInfoInputPlaceholder' |
    'contactInfoMobileInputPlaceholder' |
    'contactInfoEmailInputPlaceholder' |
    'getOtpButtonLabel' |
    'contactInfoRequiredErrorMessage' |
    'emailRequiredErrorMessage' |
    'mobileRequiredErrorMessage' |
    'contactInfoInvalidErrorMessage' |
    'emailInvalidErrorMessage' |
    'mobileInvalidErrorMessage' |
    'submitOtpButtonLabel' |
    'otpInputLabel' |
    'otpRequiredErrorMsg' |
    'otpMinLengthErrorMsg' |
    'otpExpiresInMsg' |
    'otpPatternErrorMsg' |
    'otpInputPlaceholder']: string;
};

// Default values for the resources
export const DefaultOtpComponentResource: OtpComponentResources = {
    contactInfoInputLabel: 'Mobile Number or Email',
    contactInfoMobileInputLabel: 'Mobile Number',
    contactInfoEmailInputLabel: 'Email',
    contactInfoInputPlaceholder: 'Enter your mobile number or email',
    contactInfoMobileInputPlaceholder: 'Enter your mobile number',
    contactInfoEmailInputPlaceholder: 'Enter your email',
    getOtpButtonLabel: "Sign in",
    contactInfoRequiredErrorMessage: "Email or mobile number is required",
    mobileRequiredErrorMessage: 'Mobile number is required',
    emailRequiredErrorMessage: 'Email is required',
    contactInfoInvalidErrorMessage: "Invalid Email Or Mobile Number",
    emailInvalidErrorMessage: 'Invalid Email',
    mobileInvalidErrorMessage: 'Invalid Mobile Number',
    otpInputLabel: "Enter OTP",
    otpInputPlaceholder: "Enter 6 Digit OTP",
    submitOtpButtonLabel: "Submit",
    otpRequiredErrorMsg: 'OTP is required.',
    otpMinLengthErrorMsg: 'OTP must be exactly 6 digits.',
    otpExpiresInMsg: 'OTP expires in ', // OTP expires in ${time} seconds
    otpPatternErrorMsg: 'Please enter a 6-digit number'
};
